// Settings · Industry pack — RUSSIAN (`onboarding.packUpdate.*`, D-343).

import type { Translated } from "../../../../i18n-shape.js";
import type { packUpdateEn } from "./pack-update.i18n.js";

export const packUpdateRu: Translated<typeof packUpdateEn> = {
  title: "Отраслевой пакет",
  subtitle: "Шаблон, по которому настроен ваш завод, и его обновления.",
  loading: "Загружается ваш отраслевой пакет…",
  errorTitle: "Не удалось загрузить отраслевой пакет",
  errorDetail: "Установленный пакет прочитать не удалось. Попробуйте ещё раз.",
  forbiddenTitle: "Отраслевым пакетом управляет только администратор группы",
  forbiddenBody:
    "Обновление пакета меняет определения, которыми пользуются все площадки, поэтому оно доступно только администраторам группы. Обратитесь к своему, если здесь нужно что-то изменить.",
  emptyTitle: "Отраслевой пакет ещё не установлен",
  emptyBody: "Сначала выберите и установите пакет в мастере настройки.",
  emptyCta: "Открыть настройку",
  installed: {
    heading: "Установлено",
    pack: "Пакет",
    version: "Версия",
    fingerprint: "Отпечаток содержимого",
    installedAt: "Установлен",
    live: "Завод работает",
    liveYes: "Да",
    liveNo: "Ещё нет",
    fingerprintHint:
      "Первые символы хеша содержимого пакета. Две установки с одинаковым отпечатком содержат один и тот же пакет.",
    mode: {
      install: "Установлен",
      update: "Обновлён",
    },
    status: {
      installing: "Применяется…",
      installed: "Текущий",
      failed: "Ошибка",
      superseded: "Заменён",
    },
    applying:
      "Обновление применяется. Это займёт минуту-две; страница обновится, когда всё будет готово.",
    failed:
      "Последняя установка или обновление не завершились. Откройте обновление ещё раз, чтобы повторить.",
  },
  available: {
    heading: "Доступно",
    upToDate: "У вас актуальная версия пакета.",
    upToDateWithDeclined:
      "У вас актуальная версия пакета. Изменений, которые вы не взяли и которые всё ещё доступны: {{count}}.",
    newer: "Доступна версия {{version}}.",
    chip: "Есть обновление",
    review: "Посмотреть обновление",
    previewError: "Не удалось прочитать обновление. Попробуйте ещё раз.",
    applying: "Применяется обновление. Что доступно, будет видно, когда оно завершится.",
    counts:
      "Новое: {{added}} · Изменено: {{changed}} · Убрано: {{removed}} · Ещё нет на заводе: {{missing}} · Изменений на выбор: {{acceptable}}",
    retry: "Повторить",
  },
  drawer: {
    heading: "Обновление до {{version}}",
    label: "Просмотр обновления пакета",
    close: "Закрыть",
    intro: "Новое добавляется. Изменённое применяется, только если вы это отметили.",
    liveNote:
      "Ваш завод уже работает. Здесь ничего не удаляется, и ничего из того, что вы правили, не перезаписывается.",
    nothing: "В этой версии нет ничего, что меняло бы ваши данные.",
    selectAll: "Отметить все изменения",
    selectNone: "Снять все отметки",
    summary: {
      applies: "Элементов к добавлению: {{count}}",
      accepted: "Отмечено изменений: {{count}}",
    },
    apply: "Применить обновление",
    applying: "Применяется…",
    cancel: "Отмена",
    fields: "Изменено: {{fields}}",
    accept: "Взять это изменение",
  },
  change: {
    added: "Новое",
    changed: "Изменено",
    removed: "Убрано из пакета",
    missing: "Ещё нет на заводе",
  },
  disposition: {
    applies: "Будет добавлено",
    acceptable: "На ваш выбор",
    customized: "Изменено вашей командой, сохраняется",
    adopt_only: "Ваши настройки сохраняются",
    kept: "Сохраняется, не удаляется",
    pending_module: "Ждёт, пока его модуль начнут использовать",
  },
  kinds: {
    unit: "Единицы измерения",
    attribute_schema: "Наборы атрибутов",
    catalogue_template: "Шаблоны каталога",
    qc_checklist_template: "Проверки качества",
    failure_cause: "Причины брака",
    waste_category: "Категории отходов",
    remnant_price_class: "Ценовые классы остатков",
    waste_settings: "Настройки отходов",
    waste_cause: "Причины отходов",
    downtime_reason: "Причины простоя",
    maintenance_reason_code: "Причины обслуживания",
    offcut_discount_class: "Классы скидок на обрезки",
    pipeline_stage: "Этапы сделок",
    role: "Роли",
    terminology_bundle: "Терминология",
    routing_step_template: "Шаблоны операций маршрута",
    work_center_template: "Шаблоны рабочих центров",
    machine_type: "Типы оборудования",
    label_template: "Шаблоны этикеток",
  },
  problems: {
    PACK_UPDATE_STALE:
      "Пока вы смотрели, был развёрнут более новый пакет. Просмотр обновлён — проверьте его ещё раз.",
    PACK_UP_TO_DATE: "Применять больше нечего.",
    PACK_UPDATE_NOT_ACCEPTABLE:
      "Одно из отмеченных изменений больше нельзя взять. Просмотр обновлён.",
    PACK_INSTALL_IN_PROGRESS: "Установка или обновление уже идёт. Дождитесь окончания.",
    generic: "Не удалось запустить обновление. Попробуйте ещё раз.",
  },
  applied: "Обновление применено.",
};
